import React from 'react';
import { Alert, AlertColor, Snackbar } from '@mui/material';
import { useAppSelector } from '../../hooks/useAppSelector';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import * as uiSlice from '../../data/ui.slice';
import { useTranslation } from 'react-i18next';

export default function HomeSnackbar() {
  const { t } = useTranslation('common');
  const dispatch = useAppDispatch();

  const [snackbarMessage, setSnackbarMessage] = React.useState<string | null>(
    null,
  );
  const [snackbarSeverity, setSnackbarSeverity] =
    React.useState<AlertColor>('error');

  const errorMessage = useAppSelector(uiSlice.selectErrorMessage);
  const successMessage = useAppSelector(uiSlice.selectSuccessMessage);

  React.useEffect(() => {
    if (errorMessage) {
      let msg = errorMessage?.primaryMessage?.startsWith('snackbar.')
        ? t(errorMessage.primaryMessage)
        : errorMessage.primaryMessage;
      if (errorMessage.secondaryMessage) {
        msg += `: ${errorMessage.secondaryMessage}`;
      }
      setSnackbarSeverity('error');
      setSnackbarMessage(t(msg));
    } else if (successMessage) {
      const msg = successMessage?.startsWith('snackbar.')
        ? t(successMessage)
        : successMessage;
      setSnackbarSeverity('success');
      setSnackbarMessage(t(msg));
    } else {
      setSnackbarMessage(null);
    }
  }, [errorMessage, successMessage]);

  const onSnackbarClose = () => {
    dispatch(uiSlice.clearMessages());
  };

  return (
    <Snackbar
      open={!!snackbarMessage}
      autoHideDuration={3000}
      onClose={onSnackbarClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert variant="filled" severity={snackbarSeverity}>
        {snackbarMessage}
      </Alert>
    </Snackbar>
  );
}
